
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1977',
  depVersions: {
  "customer-portal-app": "static-1.1977",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.457",
  "data-fetching-client": "static-1.9581",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.428",
  "growth-payments-core": "static-1.25077",
  "head-dlb": "static-1.4938",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5500",
  "hs-test-utils": "static-1.7918",
  "hub-http": "static-1.6125",
  "hub-http-shared-msw-handlers": "static-1.9744",
  "hubspot-dlb": "static-2.1832",
  "hubspot-prosemirror": "static-1.17960",
  "hubspot-url-utils": "static-1.4049",
  "HubStyleTokens": "static-2.11363",
  "I18n": "static-7.1604",
  "immutable": "static-2.77",
  "jasmine-runner": "static-1.6374",
  "payment-link-components": "static-1.23261",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6880",
  "quartz-core": "static-1.6099",
  "react": "static-7.184",
  "react-colorpicker": "static-2.10115",
  "react-dlb": "static-1.77",
  "react-utils": "static-2.5273",
  "rich-text-lib": "static-1.19668",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17852",
  "ui-components-test-utils": "static-1.5501",
  "UIComponents": "static-3.8310",
  "foundations-assets": "static-1.4757",
  "foundations-components": "static-1.7737",
  "foundations-theming": "static-1.4320",
  "foundations-theming-specialty": "static-1.2036",
  "framer-motion": "static-1.70",
  "history": "static-4.47",
  "metrics-js": "static-1.9542",
  "PortalIdParser": "static-2.388",
  "portals-platform-lib": "static-1.715",
  "quartz-config": "static-1.658",
  "quartz-routing": "static-1.310",
  "quick-fetch": "static-1.3841",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16563",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.8051",
  "styled-components": "static-2.88",
  "tanstack-table": "static-1.53",
  "ui-addon-draggable": "static-3.4675",
  "ui-addon-react-router-dom": "static-1.9450",
  "usage-tracker": "static-1.7241",
  "usage-tracker-anonymous": "static-1.5658",
  "usage-tracker-core": "static-1.7091",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3331",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3157",
  "quartz-webpack": "static-1.3104",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "customer-data-objects": "static-1.7565",
  "frontend-preferences-client": "static-1.7830",
  "laboratory-lib": "static-3.7065",
  "onboarding-scopes": "static-1.6371",
  "rpc-client-utils": "static-1.4550",
  "ui-addon-opt": "static-4.8289",
  "HeadJS": "static-2.736",
  "hs-test-utils-bend-plugin": "static-1.3029",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.4003",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7614",
  "cssUtils": "static-1.771",
  "customer-data-ui-utilities": "static-1.9731",
  "HubStyle": "static-2.11671",
  "knowledge-content-types": "static-1.8452",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.555",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.485",
  "ui-addon-emoji-picker": "static-1.9793",
  "ui-addon-i18n": "static-1.11054",
  "ui-business-units-lib": "static-1.8947",
  "ui-shepherd-react": "static-3.10054",
  "video-components-external": "static-1.10967",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4230",
  "commerce-tours-lib": "static-1.5921",
  "customer-data-properties": "static-1.51211",
  "getting-started-shared-tasks": "static-1.18226",
  "growth-onboarding-reliability": "static-1.4992",
  "onboarding-tours": "static-1.16428",
  "reference-resolvers-lite": "static-1.7995",
  "sales-checkout-service-client": "static-1.3569",
  "ui-addon-iframeable": "static-1.8957",
  "user-context": "static-1.5007",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "hubspotter-http": "static-1.4577",
  "icons": "static-2.639",
  "mobile-manifest-mixins": "static-1.509",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.555",
  "quartz-head": "static-1.545",
  "quartz-test": "static-1.555",
  "quartz-tracking": "static-1.259",
  "ui-fonts": "static-1.625",
  "usage-tracker-container": "static-1.7231",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9336",
  "data-token-picker": "static-1.16239",
  "FileManagerLib": "static-1.38959",
  "property-translator": "static-1.5313",
  "atom": "static-1.4977",
  "merchandise-lib": "static-1.262",
  "purchase-motions-components": "static-1.5698",
  "salesImages": "static-1.523",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5220",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1131",
  "bend-plugin-foundations-components": "static-1.4006",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "trellis-assets": "static-1.1551",
  "bend-plugin-foundations-theming": "static-1.2803",
  "foundations-theming-base": "static-1.3305",
  "stylex": "static-1.30",
  "interframe": "static-3.4669",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5655",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4379",
  "react-flip-move": "static-1.68",
  "bender-build-tools": "static-1.3063",
  "inbound-db-properties-service-client": "static-1.3771",
  "superstore": "static-1.4675",
  "chirp-fetch": "static-1.1787",
  "feedback-loader": "static-1.29120",
  "ai-components-ui-library": "static-1.8699",
  "ui-addon-video-player": "static-1.8603",
  "ui-coaching-tips": "static-1.28273",
  "sassPrefix": "static-1.154",
  "react-dnd-compat": "static-1.4524",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2400",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8073",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4557",
  "content-media-composition-data-lib": "static-1.11937",
  "content-media-compositions": "static-2.15943",
  "idb-keyval": "static-1.42",
  "immer": "static-1.33",
  "immerable": "static-1.4059",
  "magpie-lib": "static-1.5500",
  "magpie-types": "static-1.4960",
  "media-bridge-lib": "static-1.18759",
  "video-data-lib": "static-1.34625",
  "commerce-products-lib": "static-1.9179",
  "crm-message-bus": "static-1.42715",
  "growth-data-modal": "static-1.5284",
  "hubspot-apollo-client": "static-1.4784",
  "onboarding-tours-client": "static-1.4642",
  "calling-global-api": "static-1.64128",
  "calling-internal-common": "static-1.31208",
  "calling-lifecycle-internal": "static-1.65510",
  "calling-lifecycle-messages": "static-1.57804",
  "conditional-properties-service-client": "static-1.3722",
  "crm-links": "static-1.6183",
  "customer-data-objects-ui-components": "static-1.12925",
  "customer-data-properties-shared-msw-handlers": "static-1.9071",
  "customer-data-property-utils": "static-1.7990",
  "external-options-client-types": "static-1.4083",
  "file-manager-components": "static-1.23319",
  "framework-data-schema-resolvers": "static-1.6781",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.47",
  "inbound-db-meta-service-client": "static-1.3515",
  "inbounddb-objects-service-types": "static-1.4148",
  "meetings-icalendar-utils-lib": "static-1.536",
  "multi-currency-client-types": "static-1.3616",
  "object-builder-ui-client": "static-1.48415",
  "pipeline-validation-client-types": "static-1.3891",
  "property-value-citations": "static-1.1825",
  "pulse": "static-1.451",
  "smart-property-lib": "static-1.6471",
  "tiered-pricing": "static-1.1023",
  "ui-addon-form-validation": "static-1.10897",
  "growth-onboarding-confetti": "static-1.2977",
  "growth-onboarding-next-action-utils": "static-1.1632",
  "navigation-components": "static-1.17674",
  "onboarding-tours-utils": "static-1.494",
  "ui-shepherd-tracker": "static-1.7435",
  "ui-universal-auth": "static-1.8846",
  "batch-promise": "static-1.1459",
  "navigation-messaging": "static-1.7001",
  "getting-started-shared-tasks-store": "static-1.17344",
  "hubspotter-http-shared-msw-handlers": "static-1.9742",
  "usage-tracker-session-replay": "static-1.4927",
  "audio-components": "static-1.5776",
  "FileManagerCore": "static-1.38818",
  "FileManagerImages": "static-1.36470",
  "video-components": "static-1.12970",
  "foundations-components-legacy": "static-1.762",
  "nav-client-types": "static-1.2264",
  "purchase-motions-api": "static-1.5701",
  "self-service-api": "static-1.10151",
  "signup-constants": "static-1.18678",
  "signup-ui-url-generator": "static-2.7943",
  "usage-tracker-public": "static-1.7052",
  "chatspot-core": "static-1.20843",
  "ContentUtils": "static-1.68065",
  "copilot-toolkit": "static-1.10862",
  "growth-onboarding-feedback-components": "static-1.6488",
  "reactive-lib": "static-1.630",
  "simple-logging-lib": "static-1.2958",
  "commerce-permissions": "static-1.672",
  "customer-data-tracking": "static-1.6791",
  "products-iframe-lib": "static-1.7658",
  "products-ui-components-shared-msw-handlers": "static-1.10126",
  "onboarding-data-sync-lib": "static-1.1802",
  "hubspot-apollo-cache": "static-1.243",
  "calling-error-reporting": "static-1.31214",
  "shared-worker-versioning": "static-1.10944",
  "calling-usage-tracker": "static-1.6447",
  "voice-sms-access-library": "static-1.620",
  "conversations-skeleton-state": "static-1.7157",
  "location-customization-utils-lib": "static-1.8938",
  "crm-pipelines-api-client-types": "static-1.4067",
  "framework-builder-read-service-client": "static-1.3934",
  "framework-data-schema-quick-fetch": "static-1.6686",
  "persist-promise": "static-1.3616",
  "directed-graph": "static-1.844",
  "event-emitter": "static-1.854",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.48",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9827",
  "fsm": "static-1.3642",
  "policy-lib": "static-1.6690",
  "react-tinymce": "static-1.54968",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9890",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54094",
  "tinymce-plugins": "static-1.57208",
  "tinymce-themes": "static-1.56064",
  "growth-onboarding-next-action-components": "static-1.1660",
  "user-context-client": "static-1.4518",
  "nest": "static-1.129",
  "unified-auth-core-lib": "static-1.641",
  "amplitude-session-replay-browser": "static-1.58",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4438",
  "video-embed": "static-1.35459",
  "content-icons-ui": "static-1.2204",
  "social-insights-client-types": "static-1.21809",
  "eligibility-engine-service-types": "static-1.3088",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4716",
  "integrations-lib": "static-1.15806",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4169",
  "InboxConnectUtils": "static-4.14544",
  "calling-orchestration-schema": "static-1.35397",
  "crm-record-cards-service-types": "static-1.3535",
  "highcharts": "static-8.102",
  "trellis-story-utils": "static-1.4425",
  "storybook-react": "static-1.31",
  "hub-http-contrib": "static-1.2949",
  "tinymce-data": "static-1.40179",
  "ui-addon-sales-email": "static-1.5118",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12263",
  "layout-dnd-utils": "static-1.11238",
  "react-codemirror": "static-1.10530",
  "ui-brand-identity-lib": "static-1.14817",
  "NamespacedHubStyle": "static-2.8992",
  "outpost": "static-1.4101",
  "flux-actions": "static-1.325",
  "integrations-error-boundary-lib": "static-1.13221",
  "integrations-tracking-lib": "static-1.5502",
  "native-integrations-shared-strings": "static-1.7692",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10280",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.360",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68140",
  "layout-data-lib": "static-1.9563",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2913",
  "microsoft-drive-integration-lib": "static-1.40",
  "advanced-menus-core": "static-1.14983",
  "advanced-menus-lib": "static-1.11944",
  "ExportDialog": "static-6.10296",
  "ui-memberships-settings-lib": "static-1.33779",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14982",
  "simple-menus-lib": "static-1.16499"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1977",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.457",
  "data-fetching-client": "/data-fetching-client/static-1.9581",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.428",
  "growth-payments-core": "/growth-payments-core/static-1.25077",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5500",
  "hs-test-utils": "/hs-test-utils/static-1.7918",
  "hub-http": "/hub-http/static-1.6125",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9744",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17960",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyleTokens": "/HubStyleTokens/static-2.11363",
  "I18n": "/I18n/static-7.1604",
  "immutable": "/immutable/static-2.77",
  "jasmine-runner": "/jasmine-runner/static-1.6374",
  "payment-link-components": "/payment-link-components/static-1.23261",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6880",
  "quartz-core": "/quartz-core/static-1.6099",
  "react": "/react/static-7.184",
  "react-colorpicker": "/react-colorpicker/static-2.10115",
  "react-dlb": "/react-dlb/static-1.77",
  "react-utils": "/react-utils/static-2.5273",
  "rich-text-lib": "/rich-text-lib/static-1.19668",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17852",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5501",
  "UIComponents": "/UIComponents/static-3.8310",
  "foundations-assets": "/foundations-assets/static-1.4757",
  "foundations-components": "/foundations-components/static-1.7737",
  "foundations-theming": "/foundations-theming/static-1.4320",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2036",
  "framer-motion": "/framer-motion/static-1.70",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9542",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "portals-platform-lib": "/portals-platform-lib/static-1.715",
  "quartz-config": "/quartz-config/static-1.658",
  "quartz-routing": "/quartz-routing/static-1.310",
  "quick-fetch": "/quick-fetch/static-1.3841",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16563",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.8051",
  "styled-components": "/styled-components/static-2.88",
  "tanstack-table": "/tanstack-table/static-1.53",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4675",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9450",
  "usage-tracker": "/usage-tracker/static-1.7241",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5658",
  "usage-tracker-core": "/usage-tracker-core/static-1.7091",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3331",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3157",
  "quartz-webpack": "/quartz-webpack/static-1.3104",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "customer-data-objects": "/customer-data-objects/static-1.7565",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7830",
  "laboratory-lib": "/laboratory-lib/static-3.7065",
  "onboarding-scopes": "/onboarding-scopes/static-1.6371",
  "rpc-client-utils": "/rpc-client-utils/static-1.4550",
  "ui-addon-opt": "/ui-addon-opt/static-4.8289",
  "HeadJS": "/HeadJS/static-2.736",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3029",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.4003",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7614",
  "cssUtils": "/cssUtils/static-1.771",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9731",
  "HubStyle": "/HubStyle/static-2.11671",
  "knowledge-content-types": "/knowledge-content-types/static-1.8452",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.555",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9793",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11054",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8947",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10054",
  "video-components-external": "/video-components-external/static-1.10967",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4230",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5921",
  "customer-data-properties": "/customer-data-properties/static-1.51211",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18226",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4992",
  "onboarding-tours": "/onboarding-tours/static-1.16428",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7995",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8957",
  "user-context": "/user-context/static-1.5007",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "hubspotter-http": "/hubspotter-http/static-1.4577",
  "icons": "/icons/static-2.639",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.509",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.555",
  "quartz-head": "/quartz-head/static-1.545",
  "quartz-test": "/quartz-test/static-1.555",
  "quartz-tracking": "/quartz-tracking/static-1.259",
  "ui-fonts": "/ui-fonts/static-1.625",
  "usage-tracker-container": "/usage-tracker-container/static-1.7231",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9336",
  "data-token-picker": "/data-token-picker/static-1.16239",
  "FileManagerLib": "/FileManagerLib/static-1.38959",
  "property-translator": "/property-translator/static-1.5313",
  "atom": "/atom/static-1.4977",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "purchase-motions-components": "/purchase-motions-components/static-1.5698",
  "salesImages": "/salesImages/static-1.523",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5220",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1131",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4006",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.1551",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2803",
  "foundations-theming-base": "/foundations-theming-base/static-1.3305",
  "stylex": "/stylex/static-1.30",
  "interframe": "/interframe/static-3.4669",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5655",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4379",
  "react-flip-move": "/react-flip-move/static-1.68",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3771",
  "superstore": "/superstore/static-1.4675",
  "chirp-fetch": "/chirp-fetch/static-1.1787",
  "feedback-loader": "/feedback-loader/static-1.29120",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8699",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8603",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28273",
  "sassPrefix": "/sassPrefix/static-1.154",
  "react-dnd-compat": "/react-dnd-compat/static-1.4524",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2400",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8073",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4557",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11937",
  "content-media-compositions": "/content-media-compositions/static-2.15943",
  "idb-keyval": "/idb-keyval/static-1.42",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4059",
  "magpie-lib": "/magpie-lib/static-1.5500",
  "magpie-types": "/magpie-types/static-1.4960",
  "media-bridge-lib": "/media-bridge-lib/static-1.18759",
  "video-data-lib": "/video-data-lib/static-1.34625",
  "commerce-products-lib": "/commerce-products-lib/static-1.9179",
  "crm-message-bus": "/crm-message-bus/static-1.42715",
  "growth-data-modal": "/growth-data-modal/static-1.5284",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4784",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4642",
  "calling-global-api": "/calling-global-api/static-1.64128",
  "calling-internal-common": "/calling-internal-common/static-1.31208",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65510",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57804",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3722",
  "crm-links": "/crm-links/static-1.6183",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12925",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9071",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7990",
  "external-options-client-types": "/external-options-client-types/static-1.4083",
  "file-manager-components": "/file-manager-components/static-1.23319",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6781",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.47",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3515",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4148",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.536",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3616",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48415",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3891",
  "property-value-citations": "/property-value-citations/static-1.1825",
  "pulse": "/pulse/static-1.451",
  "smart-property-lib": "/smart-property-lib/static-1.6471",
  "tiered-pricing": "/tiered-pricing/static-1.1023",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10897",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2977",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1632",
  "navigation-components": "/navigation-components/static-1.17674",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.494",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7435",
  "ui-universal-auth": "/ui-universal-auth/static-1.8846",
  "batch-promise": "/batch-promise/static-1.1459",
  "navigation-messaging": "/navigation-messaging/static-1.7001",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17344",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9742",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4927",
  "audio-components": "/audio-components/static-1.5776",
  "FileManagerCore": "/FileManagerCore/static-1.38818",
  "FileManagerImages": "/FileManagerImages/static-1.36470",
  "video-components": "/video-components/static-1.12970",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.762",
  "nav-client-types": "/nav-client-types/static-1.2264",
  "purchase-motions-api": "/purchase-motions-api/static-1.5701",
  "self-service-api": "/self-service-api/static-1.10151",
  "signup-constants": "/signup-constants/static-1.18678",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7943",
  "usage-tracker-public": "/usage-tracker-public/static-1.7052",
  "chatspot-core": "/chatspot-core/static-1.20843",
  "ContentUtils": "/ContentUtils/static-1.68065",
  "copilot-toolkit": "/copilot-toolkit/static-1.10862",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6488",
  "reactive-lib": "/reactive-lib/static-1.630",
  "simple-logging-lib": "/simple-logging-lib/static-1.2958",
  "commerce-permissions": "/commerce-permissions/static-1.672",
  "customer-data-tracking": "/customer-data-tracking/static-1.6791",
  "products-iframe-lib": "/products-iframe-lib/static-1.7658",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10126",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1802",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.243",
  "calling-error-reporting": "/calling-error-reporting/static-1.31214",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10944",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6447",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.620",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7157",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8938",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4067",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3934",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6686",
  "persist-promise": "/persist-promise/static-1.3616",
  "directed-graph": "/directed-graph/static-1.844",
  "event-emitter": "/event-emitter/static-1.854",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.48",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9827",
  "fsm": "/fsm/static-1.3642",
  "policy-lib": "/policy-lib/static-1.6690",
  "react-tinymce": "/react-tinymce/static-1.54968",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9890",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54094",
  "tinymce-plugins": "/tinymce-plugins/static-1.57208",
  "tinymce-themes": "/tinymce-themes/static-1.56064",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1660",
  "user-context-client": "/user-context-client/static-1.4518",
  "nest": "/nest/static-1.129",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.641",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4438",
  "video-embed": "/video-embed/static-1.35459",
  "content-icons-ui": "/content-icons-ui/static-1.2204",
  "social-insights-client-types": "/social-insights-client-types/static-1.21809",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3088",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4716",
  "integrations-lib": "/integrations-lib/static-1.15806",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4169",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14544",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35397",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3535",
  "highcharts": "/highcharts/static-8.102",
  "trellis-story-utils": "/trellis-story-utils/static-1.4425",
  "storybook-react": "/storybook-react/static-1.31",
  "hub-http-contrib": "/hub-http-contrib/static-1.2949",
  "tinymce-data": "/tinymce-data/static-1.40179",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5118",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12263",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11238",
  "react-codemirror": "/react-codemirror/static-1.10530",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14817",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8992",
  "outpost": "/outpost/static-1.4101",
  "flux-actions": "/flux-actions/static-1.325",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13221",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5502",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7692",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10280",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.360",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68140",
  "layout-data-lib": "/layout-data-lib/static-1.9563",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2913",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.40",
  "advanced-menus-core": "/advanced-menus-core/static-1.14983",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11944",
  "ExportDialog": "/ExportDialog/static-6.10296",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33779",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14982",
  "simple-menus-lib": "/simple-menus-lib/static-1.16499"
}
};
